import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import { ButtonSize, ButtonState, ButtonType } from '../../../assets/types/dtoTypes';
import {ButtonComponent} from "../button/button.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [
    MatDialogContent,
    ButtonComponent,
    TranslateModule,
    MatDialogTitle
  ],
  standalone: true
})
export class ConfirmationDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    text: string;
}>(MAT_DIALOG_DATA);


  title = '';

  text = '';

  constructor() {
    const data = this.data;

    this.title = data.title;
    this.text = data.text;
  }

  cancel(): void {
    this.dialogRef.close( false );
  }

  confirm(): void {
    this.dialogRef.close( true );
  }

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonType = ButtonType;

  protected readonly ButtonState = ButtonState;
}
